function AppMain(p){
    return(<main className="main">{p.children}</main>);
}

export default AppMain;